<div class="container">

  <div class="left" [ngClass]="{'disabled': !leftIsActive}" (click)="leftPressed()" *ngIf="leftIsVisible">
    <app-svg-icon class="logo" [path]="'/assets/arrow_left.svg'"></app-svg-icon>
  </div>

  <div class="right" [ngClass]="{'disabled': !rightIsActive}" (click)="rightPressed()">
    {{rightText}}
    <app-svg-icon *ngIf="withIcon" class="logo" [path]="'/assets/arrow_right_2.svg'"></app-svg-icon>
  </div>

</div>
